import MultiFactorAuth from "@appComponents/MultiFactorAuth/MultiFactorAuth";
import { FundsAppContext } from "@features/context";
import { catchError, formatServerErrors } from "@features/utils/functions";
import { addInOutItem } from "@funds/components/InOutHistory/InOutHistory";
import {
  IWithdrawData,
  TWithdrawVerification,
} from "@funds/components/WithdrawVerification/IWithdrawVerification";
import FundsService from "@services/Funds.service";
import React, { useContext, useState } from "react";
import {
  WithdrawalProcessSteps,
  useWithdrawalProcess,
} from "../../useWithdrawalProcess";
import InfoBox from "@appComponents/InfoBox/InfoBox";
import Loader from "@appComponents/Loader/Loader";
import NavigationFooter from "../NavigationFooter";
import { connect } from "react-redux";
import { updateWalletBalanceAfterTransaction } from "@funds/features/action.funds";
import { TUpdateWalletData } from "@funds/interfaces/IFundsGeneral";
import { ETransactionType } from "@funds/enums/ETransactionType";

const MfaCode = (props: any) => {
  const { appLink, investorId } = useContext(FundsAppContext);
  const [state, setState] = useState<TWithdrawVerification>({
    step: 1,
    isLoading: false,
  });
  const { state: processState, setState: setProcessState } =
    useWithdrawalProcess();

  const makeWithdrawal = (_2faToken: string) => {
    const data: IWithdrawData = {
      amount: Number(processState.amount),
      percentage_amount: Number(processState.percentage_value),
      accountable_id: (processState.selectedCryptoWallet as any).id,
      accountable_type:
        processState.selectedMethod === "bankTransfer"
          ? "BankAccount"
          : "PrivateWallet",
      currency: processState.currency!,
      _2fa_token: _2faToken,
    };

    setState((state) => ({ ...state, isLoading: true }));

    FundsService.makeWithdrawal(investorId!, data)
      .then((res) => {
        if (addInOutItem) addInOutItem(res.data);
        props.updateWalletAfterTransaction({
          amount: res.data.amount!,
          type: ETransactionType.withdraw,
          currency: props.currency,
        });
        setState((prev) => ({ ...prev, isLoading: false }));
        setProcessState({
          ...processState,
          step: WithdrawalProcessSteps.CONFIRM_EMAIL,
        });
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.errors
            ? formatServerErrors(err.response.data.errors)
            : err.response.data.description;

          setState({ step: 1, isLoading: false, error: error });
        } else {
          catchError(err);
        }
      });
  };

  const renderStep = (
    <>
      {state.error && (
        <InfoBox error={true}>
          <p>{state.error}</p>
        </InfoBox>
      )}
      <MultiFactorAuth submit={makeWithdrawal} />
      <NavigationFooter
        onCancel={() => {
          setProcessState((prev) => ({
            ...prev,
            step: WithdrawalProcessSteps.WITHDRAWAL_SUMMARY,
          }));
        }}
      />
    </>
  );

  return <>{state.isLoading ? <Loader moreSpace={true} /> : renderStep}</>;
};

const mapDispatchToProps = (dispatch: Function) => ({
  updateWalletAfterTransaction: (data: TUpdateWalletData) => {
    dispatch(updateWalletBalanceAfterTransaction(data));
  },
});

export default connect(null, mapDispatchToProps)(MfaCode) as any;
